import { BaseEntity } from "./BaseEntity";

export class ConcentratorEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.isp.concentrator.concentrator";
        this.pageTitle = "components.settings.permissionManagement.menuList.Nas";
        this.menuPath = "/ISP";
        this.APIRoute = "Resources/ISP/Pool"
        this.i18nBase = "components.isp.concentrator";
        this.baseEndPoint = "radius/nas";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`
        };

        this.fieldsStep1 = [
            {
                key: "id",
                maxlength: 30,
                label: "user.fields.id",
                type: "hidden",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "name",
                maxlength: 30,
                label: "common.labels.name",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "pop_id",
                maxlength: 30,
                label: "Site/POP",
                type: "autocomplete",
                visible: true,
                required: true,
                editable: true,
                searchHandler: "handleSearchPOP",
                cols: 6,
                path: "pop_id"
            },
            {
                key: "layout_id",
                maxlength: 30,
                label: "components.settings.permissionManagement.menuList.AttributesLayout",
                type: "autocomplete",
                visible: true,
                required: true,
                editable: true,
                searchHandler: "handleSearchLayout",
                cols: 6,
                path: "layout_id"
            },
            {
                key: "manufacturer_id",
                maxlength: 30,
                label: "components.isp.manufacturerList.manufacturer",
                type: "autocomplete",
                visible: true,
                required: true,
                editable: true,
                searchHandler: "handleSearchManufacturer",
                options: [],
                path: "manufacturer_id",
                cols:6
            },
            {
                key: "description",
                maxlength: 30,
                label: "common.labels.description",
                type: "textarea",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "description"
            },
            {
                key: "status",
                maxlength: 30,
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path:"status"
            },
        ]

        this.fieldsStep2 = [
            {
                key: "ip_v4",
                maxlength: 30,
                label: "ipV4",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "ip_v4"
            },
            {
                key: "ip_v6",
                maxlength: 30,
                label: "ipV6",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "ip_v6"
            },
            {
                key: "username",
                maxlength: 30,
                label: `${this.i18nBase}.user`,
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "username"
            },
            {
                key: "password",
                maxlength: 30,
                label:`${this.i18nBase}.password`,
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "password"
            },
            {
                key: "ssh_port",
                maxlength: 30,
                label: `${this.i18nBase}.SSHport`,
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 2,
                path: "ssh_port"
            },
            {
                key: "api_port",
                maxlength: 30,
                label:`${this.i18nBase}.APIport`,
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 2,
                path: "api_port"
            },
            {
                key: "telnet_port",
                maxlength: 30,
                label: `${this.i18nBase}.telnetPort`,
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 2,
                path: "telnet_port"
            },
            {
                key: "incoming_port",
                maxlength: 30,
                label:`${this.i18nBase}.coa`,
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 2,
                path: "incoming_port"
            },
            {
                key: "radius_port",
                maxlength: 30,
                label:`${this.i18nBase}.radiusPort`,
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 2,
                path: "radius_port"
            },
            {
                key: "snmp_port",
                maxlength: 30,
                label:`${this.i18nBase}.PortSNMP`,
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 2,
                path: "snmp_port"
            },
            {
                key: "radius_secret",
                maxlength: 30,
                label: `${this.i18nBase}.secretRadius`,
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "radius_secret"
            },
            {
                key: "snmp_community",
                maxlength: 30,
                label: `${this.i18nBase}.SNMPCommunity`,
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "snmp_community"
            },
            {
                key: "pool_v4_normal_id",
                maxlength: 30,
                label: `${this.i18nBase}.generalpoolipv4`,
                type: "autocomplete",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                searchHandler: "handleSearchPool",
                path: "pool_v4_normal_id"
            },
            {
                key: "pool_v4_blocked_id",
                maxlength: 30,
                label:`${this.i18nBase}.blockingpoolipv4`,
                type: "autocomplete",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                searchHandler: "handleSearchPool",
                path: "pool_v4_blocked_id"
            },
            {
                key: "pool_v6_normal_id",
                maxlength: 30,
                label: `${this.i18nBase}.generalpoolipv6`,
                type: "autocomplete",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                searchHandler: "handleSearchPool",
                path: "pool_v6_normal_id"
            },
            {
                key: "pool_v6_blocked_id",
                maxlength: 30,
                label:`${this.i18nBase}.blockingpoolipv6`,
                type: "autocomplete",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                searchHandler: "handleSearchPool",
                path: "pool_v6_blocked_id"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                maxlength: 30,
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "ip_v4",
                maxlength: 30,
                label: "IP",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                maxlength: 30,
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                maxlength: 30,
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.Nas`,
                route: ["/isp","/isp/concentrators", "/isp/concentrator/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.Nas`,
                route: ["/isp","/isp/concentrators", "/isp/concentrator/create"]
            },
            list: {
                pageTitle: `components.settings.permissionManagement.menuList.Nas`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP`,
                route: ["/isp", "/isp/concentrators"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            },
                            {
                                key: "manufacturer_name",
                                label: "components.isp.manufacturerList.manufacturer",
                                type: "autocomplete",
                                visible: true,
                                editable: true,
                                searchHandler: "handleSearchManufacturer",
                                options: [],
                                path: "manufacturer_name",
                                itemTitle: "title",
                                itemValue: "title",
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
